import { BOARD_WIDTH, TECHNICIAN_COL_WIDTH } from '../../../shared/lib/schedule';

interface Props {
  text: string;
  action?: { label: string; onClick: () => void };
}

/**
 * The board's empty and error state. Sticky-left so the message stays readable however far the grid
 * is scrolled.
 */
export const BoardMessage = ({ text, action }: Props) => (
  <div
    className="sticky left-0 flex flex-col items-center gap-3 py-16 text-sm text-gray-400"
    style={{ width: TECHNICIAN_COL_WIDTH + BOARD_WIDTH, maxWidth: '100vw' }}
  >
    <span>{text}</span>
    {action && (
      <button
        type="button"
        onClick={action.onClick}
        className="rounded border border-slate-200 px-3 py-1.5 text-[#124093] hover:bg-gray-50"
      >
        {action.label}
      </button>
    )}
  </div>
);
